import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

type StorageType = 'token' | 'address' | 'order_rated_modal' | 'cartItems';
type StorageAddressType = 'delivery' | 'pickup';
type StorageBranchType = 'alsuper-plus' | 'alsuper' | 'fresh-market';

interface ITokenResponse {
  jwt?: string;
  refresh_token?: string;
}

interface IAddressResponse {
  displayName?: string;
  meters?: number;
  store?: number;
  storeType?: StorageBranchType;
  type?: StorageAddressType;
}

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: string) { }

  public getTokenProperty(): ITokenResponse {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem('token') || '{}');
    }
    return {};
  }

  public getAdddressProperty(): IAddressResponse {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem('address') || 'null');
    }
    return {};
  }

  public getOrderRatedProperty(): boolean | null {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem('order_rated_modal') || 'null');
    }
    return null;
  }

  public setProperty(type: StorageType, data: unknown): void {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.setItem(type, JSON.stringify(data));
    }
  }

  public getProperty(type: StorageType): any {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem(type) || 'null');
    }
  }

  public clearLocalStorage(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }

  public clearLocalStorageItem(type: StorageType): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(type);
    }
  }
}
